export const INIT_USER_PROFILE = 'INIT_USER_PROFILE'

export const FETCH_USER_PROFILE_RECORD = {
  START: 'FETCH_USER_PROFILE_RECORD_START',
  SUCCESS: 'FETCH_USER_PROFILE_RECORD_SUCCESS',
  ERROR: 'FETCH_USER_PROFILE_RECORD_ERROR'
}
